'use client';

import dynamic from 'next/dynamic';
import { ReturningUserBanner } from '@redesign/components/dashboard/landing/returning-user-banner';

const LandingWelcome = dynamic(
  () =>
    import('@redesign/components/dashboard/landing/landing-welcome').then((m) => m.LandingWelcome),
  { ssr: false }
);

export default function LandingPage() {
  return (
    <>
      <ReturningUserBanner />
      <LandingWelcome />
    </>
  );
}
